import { DATA_LAYER_EVENT_NAMES } from "../../../store/data/commonData";

export function buildVirtualPageViewDataLayerEvent(configId, step) {
  const locale = window.msizerConfiguration?.locale || "en-WW";
  const { lang, country } = {
    lang: locale?.split("-")?.[0],
    country: locale?.split("-")?.[1]
  };

  const fromMySchneider = !!window.msizerConfiguration?.seamlessToken;

  const result = {
    event: DATA_LAYER_EVENT_NAMES.PAGE_VIEW,
    digital_platform: fromMySchneider ? "Seamless" : "SE Main site",
    digital_platform_country: country,
    environment: process.env.REACT_APP_ANALYTICS_ENV,
    page_language: lang.toUpperCase(),
    configurator_name: "Motion Configurator",
    project_id: configId,
    page_sub_sub_category: step,
    from_web_view: false
  };

  if (fromMySchneider) {
    result.business_unit = "MySEFR2";
    result.page_category = "Configurator Motion";
    result.page_top_category = "Configurator";
    result.template = "Products > Configurator";
  } else {
    result.business_divisions = "Industrial Automation";
    result.page_category = "industrial-automation-control";
    result.page_sub_category = "tools";
    result.page_top_category = "products";
    result.template = "Products";
  }

  return result;
}

export function buildFileDownloadDataLayerEvent(documentName, extension) {
  const result = {
    event: DATA_LAYER_EVENT_NAMES.FILE_DOWNLOAD,
    document_type: extension,
    document_name: documentName,
    configurator_name: "Motion Configurator"
  };
  return result;
}

export function buildAddToCartDataLayerEvent(config, eventName, products = []) {
  const result = {
    event: DATA_LAYER_EVENT_NAMES.ADD_TO_CART,
    project_id: config.id,
    project_name: config.name,
    cta_name: eventName,
    add_to_cart_location: config.step,
    configurator_name: "Motion Configurator",
    ecommerce: {
      items: products.map((refObj) => {
        return {
          item_id: refObj.commercialReference,
          item_name: refObj.commercialReference,
          quantity: refObj.quantity
        };
      })
    }
  };
  return result;
}

export function logDataLayerEvent(payload) {
  const fromMySchneider = !!window.msizerConfiguration?.seamlessToken;

  //console.log(payload);

  if (fromMySchneider) {
    document.dispatchEvent(
      new CustomEvent("track_iac_analytics", {
        bubbles: true,
        detail: payload
      })
    );
  } else {
    let dataLayerObject;
    try {
      if (window.top !== window.self) {
        dataLayerObject = window.top?.dataLayer;
      } else {
        dataLayerObject = window.dataLayer;
      }
    } catch (err) {
      console.warn("Data layer is not defined", err);
    }

    if (dataLayerObject != null) {
      try {
        dataLayerObject.push(payload);
      } catch (err) {
        console.warn("Failed to push to the data layer");
      }
    }
  }
}
